// Reads the TrustedForm certificate URL from the hidden input that the
// TrustedForm runtime (loaded via TrustedFormLoader) populates during the
// session. Called at Step 4 submit time so the latest cert URL goes into the
// lead payload and the cert can be retained downstream. Read fresh on each
// call, never cached, since the runtime keeps updating the value as the user
// interacts with the page.

export function readTrustedFormCert() {
  try {
    const field = document.querySelector(
      'input[name="xxTrustedFormCertUrl"]'
    );
    if (!field) return null;
    const value = (field.value || "").trim();
    // Keep null (not "") when missing, matching how tracking handles absent
    // values, so JSON.stringify preserves a consistent key shape.
    return value !== "" ? value : null;
  } catch (err) {
    // No document / no field / sandboxed context: never throw so Step 4 can
    // still submit even if TrustedForm failed to load.
    return null;
  }
}
